import {
  type InstanceOutboundChannel,
  type TenantFeature,
  tenantHasWhatsAppModule,
} from '@workspace/types';

const CHANNELS: Array<{ id: InstanceOutboundChannel; label: string; feature: TenantFeature | 'whatsapp-module' | null }> = [
  { id: 'WHATSAPP', label: 'WhatsApp', feature: 'whatsapp-module' },
  { id: 'SMS', label: 'SMS', feature: 'sms-integration' },
  { id: 'EMAIL', label: 'Email', feature: 'email-integration' },
];

export function InstanceOutboundChannelsCard({
  tenantFeatures,
  value,
  onChange,
}: {
  tenantFeatures: TenantFeature[];
  value: InstanceOutboundChannel[];
  onChange: (next: InstanceOutboundChannel[]) => void;
}) {
  const safeFeatures = Array.isArray(tenantFeatures) ? tenantFeatures : [];
  const features = new Set(safeFeatures);
  const safeValue = Array.isArray(value) ? value : [];
  return (
    <div className='space-y-3 rounded-xl border p-4'>
      <div>
        <p className='text-sm font-medium'>Esta instancia puede usar</p>
        <p className='text-xs text-muted-foreground'>
          SMS y email se habilitan en el tenant primero. WhatsApp queda disponible para campañas.
        </p>
      </div>
      {CHANNELS.map(channel => {
        const locked =
          channel.feature === 'whatsapp-module'
            ? !tenantHasWhatsAppModule(safeFeatures)
            : Boolean(channel.feature && !features.has(channel.feature));
        const checked = safeValue.includes(channel.id);
        return (
          <label key={channel.id} className='flex items-start gap-3 text-sm'>
            <input
              type='checkbox'
              checked={checked}
              disabled={locked}
              title={locked ? 'Habilitalo en el tenant primero.' : undefined}
              onChange={() =>
                onChange(
                  checked
                    ? safeValue.filter(item => item !== channel.id)
                    : [...safeValue, channel.id],
                )
              }
            />
            <span>
              {channel.label}
              {locked ? (
                <span className='ml-2 text-xs text-muted-foreground'>Habilitalo en el tenant primero.</span>
              ) : null}
            </span>
          </label>
        );
      })}
    </div>
  );
}
